import OurProjectForm from "../component/OurProjectForm";

const OurProjectCreate = () => {
  return <OurProjectForm isEditMode={false} />;
};

export default OurProjectCreate;
